import useApi from "../../api/useApi";
import useFunction from "../../hooks/useFunction";

const useAlertService = () => {

  const {api} = useApi()
  const {c} = useFunction()

  const userShowCollection = (callbackSuccess, callbackValidationErrors) => {
    return api(
      'get',
      'user/alerts',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useAlertService::userShowCollection: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  const userStore = (callbackSuccess, callbackValidationErrors, filter) => {
    return api(
      'post',
      'user/alert/store',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useAlertService::userStore: ${error?.message || JSON.stringify(error)}`)},
      filter
    )
  }

  const userDelete = (callbackSuccess, callbackValidationErrors, alertId) => {
    return api(
      'post',
      'user/alert/' + alertId + '/delete',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useAlertService::userDelete: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  return {
    objectType:'alert',
    userShowCollection,
    userStore,
    userDelete
  }
}

export default useAlertService
